import React from "react"
import AppContext from "@contexts/AppContext"
import { graphql, Link } from "gatsby"
import styled from "styled-components"

import Layout from "@components/Layout"
import PostCard from "@components/PostCard"
import SEO from "@components/SEO"


const Wrapper = styled.div`
  .title {
    margin: 0 0 40px;
    font-size: 37px;
    user-select: none;
    text-align: center;
    color: ${({ theme }) => theme.text.primary};
    vertical-align: text-bottom;
  }
  @media screen and (max-width: 600px) {
    margin: 40px 20px;
  }
`

const MainContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;
  margin-bottom: 40px;
  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

const Pagination = styled.div`
  display: flex;
  user-select: none;
  justify-content: center;
  margin: 40px auto;
  a {
    display: inline-flex;
    height: 40px;
    width: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    text-decoration: none;
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => theme.primary.main};
    &:hover {
      transition: all 0.3s ease;
      background: rgba(77, 171, 245, 0.5);
      color: white;
    }
  }
  .abridgement {
    background: rgba(0, 0, 0, 0) !important;
    &:hover {
      color: ${({ theme }) => theme.primary.main} !important;
    }
  }
  .active {
    color: white;
    background: ${({ theme }) => theme.primary.main} !important;
  }
`

const BlogList = ({ data, location, pageContext }) => {
  const title = data.site.siteMetadata?.title || `Title`
  const posts = data.allMdx.nodes
  const categories = data.site.siteMetadata.categories

  const recommendPost = ["/example3/", "/example2/"]

  // pagination
  // ref: https://www.gatsbyjs.com/docs/adding-pagination/
  // ref: https://nickymeuleman.netlify.app/blog/gatsby-pagination
  const { currentPage, numPages } = pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages;
  const prevPage = currentPage - 1 === 1 ? "/" : `/page/${currentPage - 1}/`
  const nextPage = `/page/${currentPage + 1}/`

  return (
    <AppContext.Provider value={{ title, slug: location.pathname }}>
      <Layout location={location} title={title}>
        <Wrapper>
          <SEO
            title="All posts"
            image={null}
          />
          {isFirst && (
            <>
              <div class="title"><span>おすすめ記事</span></div>
              <MainContent>
                {posts
                  .filter(post => recommendPost.includes(`${post.fields.slug}`))
                  .map(post => {
                    const categoryObject = categories.find((category => {
                      if (post.frontmatter.category.length === 1) {
                        return category.slug === post.frontmatter.category[0];
                      }
                      else {
                        return category.slug === post.frontmatter.category[1];
                      }
                    }))

                    const categoryUrl = categoryObject.mom === null
                      ? `/category/${categoryObject.slug}/`
                      : `/category/${categoryObject.mom}/${categoryObject.slug}/`

                    return (
                      <PostCard
                        key={post.fields.slug}
                        title={post.frontmatter.title}
                        category={categoryObject.slug}
                        categoryUrl={categoryUrl}
                        date={post.frontmatter.date}
                        update={post.frontmatter.update}
                        url={post.fields.slug}
                        hero={post.frontmatter.hero === null ? null : post.frontmatter.hero.childImageSharp.fluid}
                      />
                    )
                  })}
              </MainContent>
            </>
          )}
          <div class="title"><span>記事一覧</span></div>
          <MainContent>
            {posts.map(post => {
              const categoryObject = categories.find((category => {
                if (post.frontmatter.category.length === 1) {
                  return category.slug === post.frontmatter.category[0];
                }
                else {
                  return category.slug === post.frontmatter.category[1];
                }
              }))

              const categoryUrl = categoryObject.mom === null
                ? `/category/${categoryObject.slug}/`
                : `/category/${categoryObject.mom}/${categoryObject.slug}/`

              return (
                <PostCard
                  key={post.fields.slug}
                  title={post.frontmatter.title}
                  category={categoryObject.slug}
                  categoryUrl={categoryUrl}
                  date={post.frontmatter.date}
                  update={post.frontmatter.update}
                  url={post.fields.slug}
                  hero={post.frontmatter.hero === null ? null : post.frontmatter.hero.childImageSharp.fluid}
                />
              )
            })}
          </MainContent>
          <Pagination>
            {!isFirst && (
              <Link to={prevPage} rel="prev">
                &lt;
              </Link>
            )}
            {numPages <= 7 &&
              Array.from({ length: numPages }, (_, i) => (
                <Link
                  key={`pagination-number${i + 1}`}
                  to={`/${i === 0 ? "" : `page/${i + 1}/`}`}
                  activeClassName="active"
                >
                  {i + 1}
                </Link>
              ))
            }
            {8 <= numPages &&
              <>
                <Link
                  key={`pagination-number${1}`}
                  to={`/`}
                  activeClassName="active"
                >
                  1
              </Link>
                {currentPage <= 4
                  ?
                  <Link
                    key={`pagination-number${2}`}
                    to={`/page/2/`}
                    activeClassName="active"
                  >
                    2
              </Link>
                  :
                  <Link
                    className="abridgement"
                    key={`pagination-number${2}`}
                  >
                    ...
              </Link>
                }
                {Array.from({ length: 3 }, (_, i) => (
                  <>
                    {5 > currentPage &&
                      <Link
                        key={`pagination-number${i + 3}`}
                        to={`/page/${i + 3}/`}
                        activeClassName="active"
                      >
                        {i + 3}
                      </Link>
                    }
                    {(5 <= currentPage && currentPage <= numPages - 4) &&
                      <Link
                        key={`pagination-number${i + currentPage - 1}`}
                        to={`/page/${i + currentPage - 1}/`}
                        activeClassName="active"
                      >
                        {i + currentPage - 1}
                      </Link>
                    }
                    {currentPage > numPages - 4 &&
                      <Link
                        key={`pagination-number${i + numPages - 4}`}
                        to={`/page/${i + numPages - 4}/`}
                        activeClassName="active"
                      >
                        {i + numPages - 4}
                      </Link>
                    }
                  </>
                ))}
                {numPages - 3 <= currentPage
                  ?
                  <Link
                    key={`pagination-number${numPages - 1}`}
                    to={`/page/${numPages - 1}/`}
                    activeClassName="active"
                  >
                    {numPages - 1}
                  </Link>
                  :
                  <Link
                    key={`pagination-number${numPages - 1}`}
                    className="abridgement"
                  >
                    ...
              </Link>
                }
                <Link
                  key={`pagination-number${numPages}`}
                  to={`/page/${numPages}/`}
                  activeClassName="active"
                >
                  {numPages}
                </Link>
              </>
            }
            {!isLast && (
              <Link to={nextPage} rel="next">
                &gt;
              </Link>
            )}
          </Pagination>
        </Wrapper>
      </Layout>
    </AppContext.Provider>
  )
}

export default BlogList;

export const pageQuery = graphql`
  query blogListQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
        categories {
          name
          slug
          mom
        }
      }
    }
    allMdx(
      filter: {fileAbsolutePath: {regex: "/blog/"}}, 
      sort: {fields: frontmatter___date, order: DESC}
      limit: $limit
      skip: $skip
    ) {
      nodes {
        fields {
          slug
        }
        slug
        frontmatter {
          title
          date(formatString: "YYYY/MM/DD")
          update(formatString: "YYYY/MM/DD")
          description
          category
          hero {
            childImageSharp {
              fluid(maxWidth: 1350) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
      totalCount
    }
  }
`